import { useTranslation } from "react-i18next";
import CustomButton from "../buttons/CustomButton";
import { NavigateNext } from "@mui/icons-material";
import { NavigateBefore } from "@mui/icons-material";
import PublishIcon from "@mui/icons-material/Publish";
import CircularProgress from "@mui/material/CircularProgress";

export default function WizardNav({
  back,
  next,
  canGoNext,
  isFirst,
  isLast,
  onSubmit,
  isSubmitting = false,
}) {
  const { t } = useTranslation();
  return (
    <div className="wz-nav">
      {!isFirst && (
        <CustomButton
          startIcon={<NavigateBefore />}
          type="button"
          onClick={back}
          disabled={isSubmitting}
        >
          {t("common.back")}
        </CustomButton>
      )}

      {!isLast ? (
        <CustomButton
          type="button"
          endIcon={<NavigateNext />}
          onClick={next}
          disabled={!canGoNext || isSubmitting}
        >
          {t("common.next")}
        </CustomButton>
      ) : (
        <CustomButton
          type="button"
          onClick={onSubmit}
          disabled={!canGoNext || isSubmitting}
          startIcon={
            isSubmitting ? (
              <CircularProgress size={18} sx={{ color: "inherit" }} />
            ) : (
              <PublishIcon />
            )
          }
        >
          {t("createDataOfferingsDetail.title")}
        </CustomButton>
      )}
    </div>
  );
}
